<dv-dynamic-form
  class="driver-form"
  [elements]="driverElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form
><dv-dynamic-form
  class="trip-detail-form"
  formTitle="{{ 'TripInformationTab.TripDetails' | translate | uppercase }}"
  [elements]="tripDetailElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
@if ((isMapVisible$ | async) && tripMarkers) {
  <app-map
    [id]="mapId"
    class="trip-map"
    [markers]="tripMarkers"
    [invalidateSize$]="splitterEvents.resizeEnd$"></app-map>
}
<dv-dynamic-form
  class="driver-form"
  [elements]="purposeElements | translateElements"
  [formGroup]="formGroup">
</dv-dynamic-form>
<div class="trip-type-wrapper">
  <dv-dynamic-form
    class="trip-type-wrapper__form"
    formTitle="{{ 'TripInformationTab.TripType' | translate | uppercase }}"
    [elements]="tripTypeElements | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  @if (currentVehicleType === vehicleTypeEnum.Corporate) {
    <div class="driving-info-area">
      <div class="driving-info-area__days label">
        <p>
          {{ 'TripInformationTab.PrivateOccasionalCount' | translate }}
        </p>
        <b
          >{{ formGroup.controls.PrivateOccasionalCount?.value || 0 }}
          {{ 'TripInformationTab.Days' | translate }}</b
        >
      </div>
      <div class="driving-info-area__distance label">
        <p>
          {{ 'TripInformationTab.PrivateOccasionalDistance' | translate }}
        </p>
        <b
          >{{ formGroup.controls.PrivateOccasionalDistance?.value || 0 }}
          {{ 'TripInformationTab.Kilometres' | translate }}</b
        >
      </div>
    </div>
  }
</div>
<dv-save-panel
  [editPermissions]="{
    formGroup,
    permissions: [userPermissions.TripEdit],
  }"
  labelCancel=""
  [disableSave]="!formGroup.dirty || !formGroup.valid"
  labelSave="{{ 'General.Save' | translate }}"
  (save)="onSave()">
</dv-save-panel>
